import { ScrollReveal } from '@/components/ui/ScrollReveal';
import { useTranslation } from 'react-i18next';

export const Philosophy = () => {
  const { t } = useTranslation('home');

  return (
    <section className="bg-background py-32 px-6" aria-labelledby="filosofia-heading">
      <div className="mx-auto max-w-4xl text-center">
        <ScrollReveal>
          <span className="mb-6 inline-block text-sm font-light uppercase tracking-[0.3em] text-primary">
            {t('philosophy.label')}
          </span>
        </ScrollReveal>

        <ScrollReveal delay={100}>
          <h2 id="filosofia-heading" className="mb-10 text-4xl font-semibold leading-tight text-foreground md:text-5xl">
            {t('philosophy.title')}
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={200}>
          <p className="text-lg font-light leading-relaxed text-muted-foreground md:text-xl">{t('philosophy.text')}</p>
        </ScrollReveal>

        <ScrollReveal delay={300}>
          <div className="mt-16 flex flex-wrap items-center justify-center gap-16">
            <div className="text-center">
              <span className="block text-4xl font-bold text-primary">30+</span>
              <span className="mt-2 block text-sm uppercase tracking-wider text-muted-foreground">{t('philosophy.stat1')}</span>
            </div>
            <div className="h-12 w-[1px] bg-border hidden md:block" />
            <div className="text-center">
              <span className="block text-4xl font-bold text-primary">100%</span>
              <span className="mt-2 block text-sm uppercase tracking-wider text-muted-foreground">{t('philosophy.stat2')}</span>
            </div>
            <div className="h-12 w-[1px] bg-border hidden md:block" />
            <div className="text-center">
              <span className="block text-4xl font-bold text-primary">∞</span>
              <span className="mt-2 block text-sm uppercase tracking-wider text-muted-foreground">{t('philosophy.stat3')}</span>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};
